/**
 * This is an i18n hook function for low-level libraries.
 * @param {string} text the text to be translated
 * @returns {string} the same text, this may be intercepted and replaced by the real i18n framework.
 */
export const t = (text) => text
